import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';


export interface Usuario {
  id: string;
  nombre: string;
  email: string;
  tipo: 'organizacion' | 'plataforma_general';
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private readonly API_URL = 'https://chagual.territoriosentransformacion.cl/api_php';
  private readonly USUARIO_ACTUAL_KEY = 'usuarioActual';
  private readonly TOKEN_KEY = 'authToken';

  private usuarioActual: Usuario | null = null;

  constructor(private http: HttpClient) {
    this.cargarUsuarioActual();
  }

  // Iniciar sesión contra MySQL via PHP
  async login(email: string, password: string): Promise<{ success: boolean; message: string }> {
    try {
      const response = await this.http.post<any>(`${this.API_URL}/login.php`, { email, password }).toPromise();
      

  if (response.success) {
  this.usuarioActual = {
    ...response.usuario,
    id: String(response.usuario.id)  // ← convierte number a string
  };
  localStorage.setItem(this.USUARIO_ACTUAL_KEY, JSON.stringify(this.usuarioActual));
  localStorage.setItem(this.TOKEN_KEY, response.token);
  return { success: true, message: 'Inicio de sesión exitoso' };
  } else {
        return { success: false, message: response.message || 'Credenciales incorrectas' };
      }

    } catch (error: any) {
      const msg = error?.error?.message || 'Error al conectar con el servidor';
      return { success: false, message: msg };
    }
  }

  // Cerrar sesión
  async logout(): Promise<void> {
    this.usuarioActual = null;
    localStorage.removeItem(this.USUARIO_ACTUAL_KEY);
    localStorage.removeItem(this.TOKEN_KEY);
  }

  // Verificar si hay usuario autenticado
  async estaAutenticado(): Promise<boolean> {
    if (this.usuarioActual) return true;
    this.cargarUsuarioActual();
    return this.usuarioActual !== null;
  }

  // Obtener usuario actual
  getUsuarioActual(): Usuario | null {
    return this.usuarioActual;
  }

  // Obtener token
  getToken(): string | null {
    return localStorage.getItem(this.TOKEN_KEY);
  }

  // Cargar usuario desde localStorage (persistencia de sesión)
  private cargarUsuarioActual(): void {
    const usuarioJson = localStorage.getItem(this.USUARIO_ACTUAL_KEY);
    this.usuarioActual = usuarioJson ? JSON.parse(usuarioJson) : null;
  }
}